import type z from 'zod/v4'
import { relations, sql } from 'drizzle-orm'
import { boolean, index, integer, pgTable, text, timestamp, uniqueIndex, uuid } from 'drizzle-orm/pg-core'
import { createInsertSchema, createSelectSchema, createUpdateSchema } from 'drizzle-zod'

import { user } from '../auth'
import { BookCollection } from '../content'

export const LoveBookCollection = pgTable(
  'love_book_collection',
  {
    id: uuid().primaryKey().defaultRandom(),
    userId: text().references(() => user.id, { onDelete: 'cascade' }),
    bookCollectionId: uuid()
      .references(() => BookCollection.id, { onDelete: 'cascade' })
      .notNull(),
    calculatedMetrics: boolean().default(false).notNull(),
    calculatedForMonthlyMetrics: boolean().default(false).notNull(),
    updatedAt: timestamp({ mode: 'date', withTimezone: true }).$onUpdateFn(() => sql`now()`),
    createdAt: timestamp({ mode: 'date', withTimezone: true }).defaultNow().notNull(),

    // LEGACY
    legacyFavoriteCollectionId: integer(),
  },
  (t) => [
    index('idx_love_book_collection_user').on(t.userId),
    index('idx_love_book_collection_book_collection').on(t.bookCollectionId),
    index('idx_love_book_collection_monthly_metrics').on(t.calculatedForMonthlyMetrics),
    uniqueIndex('love_book_collection_user_book_collection_uidx').on(t.userId, t.bookCollectionId),
  ],
)

export const loveBookCollectionRelations = relations(LoveBookCollection, ({ one }) => ({
  bookCollection: one(BookCollection, {
    fields: [LoveBookCollection.bookCollectionId],
    references: [BookCollection.id],
  }),

  user: one(user, {
    fields: [LoveBookCollection.userId],
    references: [user.id],
  }),
}))

export const InsertLoveBookCollectionSchema = createInsertSchema(LoveBookCollection).omit({
  id: true,
  createdAt: true,
})

export const UpdateLoveBookCollectionSchema = createUpdateSchema(LoveBookCollection).partial().omit({
  id: true,
  userId: true,
  bookCollectionId: true,
  createdAt: true,
})

export const SelectLoveBookCollectionSchema = createSelectSchema(LoveBookCollection)

export type InsertLoveBookCollection = typeof LoveBookCollection.$inferInsert
export type UpdateLoveBookCollection = z.infer<typeof UpdateLoveBookCollectionSchema>
export type SelectLoveBookCollection = typeof LoveBookCollection.$inferSelect
